// core
import React from "react";
import { useFormikContext } from "formik";

// hooks
import useSettingsValidation from "../../hooks/useSettingsValidation";
import {
    calculateMaxMortgageMonthlyRepayments,
    maxMonthlyMortgageCoverPercentage
} from "../../../common/shared/productHelpers";

// components
import { IStreamlineSettingsClientProps } from "./StreamlineBaseClientSettings";
import ClientSettingsBoxOccupation from "../Clients/ClientSettingsBoxOccupation/ClientSettingsBoxOccupation";
import MonthlyCoverSlider from "../../../common/components/Forms/MonthlyCoverSlider/MonthlyCoverSlider";

// interfaces
import { IQuoteSettings } from "../../interfaces/form/IQuoteSettings";
import ProductType from "../../../common/interfaces/enums/ProductType";

const StreamlineMortgageSettings: React.FC<IStreamlineSettingsClientProps> = (props) => {
    const { client, name } = props;
    const {
        setFieldValue,
        setFieldTouched,
        handleChange,
        validateField,
        values
    } = useFormikContext<IQuoteSettings>();
    const { getFormikError } = useSettingsValidation();

    const maxMonthlyCover = calculateMaxMortgageMonthlyRepayments(
        values[ProductType.Mortgage]?.repaymentAmount,
        values[ProductType.Mortgage]?.repaymentFrequency
    );

    return (
        <React.Fragment>
            <ClientSettingsBoxOccupation
                client={client}
                name={`${name}`}
                setClient={handleChange}
            />
            <MonthlyCoverSlider
                name={`${name}.${ProductType.Mortgage}.monthlyCover`}
                label={"Monthly Repayment Cover"}
                maxValue={maxMonthlyCover}
                value={client[ProductType.Mortgage]?.monthlyCover}
                onChange={(monthlyCover) => {
                    setFieldValue(
                        `${name}.${ProductType.Mortgage}.monthlyCover`,
                        monthlyCover
                    );
                }}
                onBlur={() => {
                    setFieldTouched(`${name}.${ProductType.Mortgage}.monthlyCover`);
                    validateField(`${name}.${ProductType.Mortgage}.monthlyCover`);
                }}
                isDisabled={!maxMonthlyCover || maxMonthlyCover <= 0}
                percentageRangeMax={maxMonthlyMortgageCoverPercentage}
                hasInput
                isCurrency
                isRoundUp={false}
                tooltipContent="Repayment Cover pays up to 110% of your repayments if you are too sick to work. Payments start after your chosen Wait Period."
                hasError={getFormikError(`${name}.${ProductType.Mortgage}.monthlyCover`)}
            />
        </React.Fragment>
    );
};

export default StreamlineMortgageSettings;
